import {NgModule} from '@angular/core';
import {NgForOf, NgIf} from "@angular/common";
import {NewsListComponent} from "@iw-shop/news/components/list/news-list.component";
import {NewsTemplateComponent} from "@iw-shop/news/components/template/news-template.component";
import {NewsModalComponent} from "@iw-shop/news/components/modal/news-modal.component";

@NgModule({
    declarations: [
        NewsListComponent,
        NewsTemplateComponent,
        NewsModalComponent
    ],
    imports: [
        NgIf,
        NgForOf
    ],
    exports: [
        NewsListComponent,
        NewsTemplateComponent,
        NewsModalComponent
    ]
})
export class NewsModule {
}
